// extracted by mini-css-extract-plugin
module.exports = {"component":"SettingsPage_component__12Y9p","wrapper":"SettingsPage_wrapper__iRwDJ","content":"SettingsPage_content__2gXSj","buttons":"SettingsPage_buttons__qwOZN"};